export default {
    en: {
        home: 'Home',
        productdivision: 'Product division',
        use_our_system: 'Use our system to find your product division provider',
        find: 'Find your sales Representative',
        support_for: 'Sales Representative for',
        contact_poland: 'For this country please contact product division support in Poland.',
        contact_error: 'We apologize, something went wrong.',
        vacumm: 'Vacuum Furnacexxxx',
        aluminium: 'Aluminium & Cab Furnace',
        thermal: 'Thermal Furnace',
        metalurgy: 'Vacuum Metallurgy Furnace'
    },
    de: {
        home: 'Home',
        productdivision: 'Product division',
        use_our_system: 'Nutzen Sie unser System um Ihren Dienstleister zu finden',
        find: 'Finde dein product division',
        support_for: 'Support für',
        contact_poland: 'Für dieses Land wenden Sie sich bitte an den Kundendienst in Polen',
        contact_error: 'Wir entschuldigen uns es ist ein Fehler aufgetreten',
        vacumm: 'Vacuum-Ofen',
        aluminium: 'Aluminium & Cab Ofen',
        thermal: 'Thermal Ofen',
        metalurgy: 'Vacuum Metallurgie Ofen'
    },
    pl: {
        home: 'Główna',
        productdivision: 'Serwis',
        use_our_system: 'Skorzystaj z formularza i znajdź wsparcie',
        find: 'Znajdź Swój serwis',
        support_for: 'Wsparcie dla',
        contact_poland: 'Dla tego kraju za wsparcie odpowiada centrala w Polsce',
        contact_error: 'Przepraszamy coś poszło nie tak.',
        vacumm: 'Próżniowa Obróbka Cieplna',
        aluminium: 'Obróbka Cieplna Aluminium i CAB',
        thermal: 'Obróbka Cieplna w Atmosferze',
        metalurgy: 'Metalurgia Próżniowa'
    },
    ru: {
        home: 'Дом (Главная)',
        productdivision: 'Сервис',
        use_our_system: 'Используйте нашу систему, чтобы найти поставщика услуг',
        find: 'Найди свой сервис',
        support_for: 'Поддержка для',
        contact_poland: 'Для этой страны, пожалуйста, свяжитесь со службой поддержки в Польше.',
        contact_error: 'Приносим свои извинения, что-то пошло не так',
        vacumm: 'Вакуумная печь',
        aluminium: 'Алюминиевая печь и печь CAB',
        thermal: 'Термальная печь',
        metalurgy: 'Вакуумная металлургическая печь'
    }
}
